import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const CHUNK_RELOAD_KEY = 'hrm_chunk_reload_at';
const CHUNK_RELOAD_COOLDOWN_MS = 60 * 1000;

function recoverFromStaleChunk(reason) {
  const message = String(reason?.message || reason || '');
  const isChunkFailure = /ChunkLoadError|Loading chunk .* failed|Failed to fetch dynamically imported module/i.test(message);
  if (!isChunkFailure) return;

  try {
    const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - lastReload < CHUNK_RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (_error) {
    // Continue with one recovery reload when storage is unavailable.
  }

  window.location.reload();
}

window.addEventListener('error', (event) => recoverFromStaleChunk(event.error || event.message));
window.addEventListener('unhandledrejection', (event) => recoverFromStaleChunk(event.reason));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration);

        // Periodically check for updates (e.g. every hour or on navigation)
        registration.update();

        // Listen for new service worker installation
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New content is available; please refresh.');
                // Automatically activate the new service worker
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });

  // Reload the page when the service worker changes control (after SKIP_WAITING)
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      console.log('Service worker updated. Reloading page...');
      window.location.reload();
    }
  });
}

// Performance monitoring
reportWebVitals();
